import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Settings", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilesList = _resolveComponent("FilesList")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_TemplateForm = _resolveComponent("TemplateForm")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "Files" }, {
          default: _withCtx(() => [
            _createVNode(_component_FilesList)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "Template Email" }, {
          default: _withCtx(() => [
            _createVNode(_component_TemplateForm)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}